import React from 'react';

const CustomImgMessage = (props) => {
  //console.log(props);
  const _prev = () => {
    const preText = props.state.prevMessage;
    //console.log(preText);
    props.actions._categoryPrev(preText);
  };
  return (
    <>
      <div className="ir-chat-contaner">
        <div className="custom-chat-div">
          <div className="custom-chat-div-left">
            <img src="/img/icon_chatbot.png" />
          </div>
          <div className="custom-chat-div-right">
            <div className="ri-chat-message-bot">
              <div className="ri-chat-message-bot-with-icon">
                <img
                  src={'/img/' + props.payload.icon}
                  style={{ width: '100%' }}
                />
                <div className="ri-chat-message-bot-with-ico-message">
                  {props.payload.message}
                </div>
              </div>
            </div>

            <div className="ri-chat-time">{props.payload.writetime}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomImgMessage;
